import { IPickupDate } from '@src/models/api';

export const MORE_DATES_VALUE = '__more_dates__';
export const REQUEST_DIFFERENT_DATE_VALUE = '__request_different_date__';
export const DATE_TIME_ADJUSTMENT = 'T00:00:00';

// Get the calendar date range and unavailable days from LORP scheduled pickup slots
export const getDates = (slots: IPickupDate[]) => {
  const toStartOfDay = (input: string | Date) => {
    const date = typeof input === 'string' ? new Date(input) : input;
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  };

  // Treat a day as "available" if it appears in the list (by startDateTime day)
  const availableDayTimes = Array.from(
    new Set(slots.map((slot) => toStartOfDay(slot.date).getTime())),
  );

  const minTime = Math.min(...availableDayTimes);
  const maxTime = Math.max(...availableDayTimes);
  const minDate = new Date(minTime);
  const maxDate = new Date(maxTime);

  // Build every day in the [minDate..maxDate] range
  const msPerDay = 24 * 60 * 60 * 1000;
  const totalDays = Math.floor((maxTime - minTime) / msPerDay) + 1;
  const allDays = Array.from(
    { length: totalDays },
    (_unused, i) =>
      new Date(
        minDate.getFullYear(),
        minDate.getMonth(),
        minDate.getDate() + i,
      ),
  );

  // Unavailable = days not present in the available set
  const availableSet = new Set(availableDayTimes);
  const unavailableDates = allDays.filter(
    (day) => !availableSet.has(day.getTime()),
  );

  return { minDate, maxDate, unavailableDates };
};

export const findSlotDateByCalendarDay = (
  slots: IPickupDate[],
  day: Date | string,
): string | undefined => {
  const startOfDayTime = (value: Date | string) => {
    const date = typeof value === 'string' ? new Date(value) : value;
    return new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
    ).getTime();
  };

  const target = startOfDayTime(day);
  return (
    slots.find((slot) => startOfDayTime(slot.date) === target)?.date ??
    undefined
  );
};
